// src/api/adminAuditApi.js
import { adminJson } from "./adminHttp";

export function listAuditLogs(page = 0, size = 50) {
  return adminJson(`/admin/audit-logs?page=${page}&size=${size}`);
}
